import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import LoadingLayer from 'common/components/LoadingLayer'
import Header from 'common/components/Header'
import Content from 'common/components/Content'
import Menu from 'common/components/Menu'
import RegistrationWrapper from './RegistrationWrapper'

const Signup = () => {
  const { t } = useTranslation()
  const loading = useSelector(state => state.loading)
  return (
    <div className="container">
      <LoadingLayer loading={loading} />
      <Menu />
      <div className="right-bar">
        <Header>
          <div className="header-container">
            <div className="breadcrumb">
              <span>{t('Signup')}</span>
            </div>
            <div className="header-buttons-container">
              <button type="submit" form="signup-form" className="header-button">
                <span>Submit</span>
              </button>
            </div>
          </div>
        </Header>
        <Content>
          <RegistrationWrapper />
        </Content>
      </div>
    </div>
  )
}

export default Signup
